import type { VisibilityMap } from "../../../../../../components/Questionnaire/validation/form/types";
import type { Groups, Answers } from "../../../../types";
import { isShadowGroup } from "../../../../types";
import { deriveShadowChildrenAnswers } from "../shared/deriveShadowChildrenAnswers";

type DeriveYesGroupUpdatesArgs = {
  groupNames: string[];
  groups: Groups;
  answers: Answers;
  visibility: VisibilityMap;
  serverVisibleByName: Record<string, boolean>;
};

/**
 * Pure helper: derive answers and visibility when a normal group is set to "yes"
 */
export const deriveYesGroupUpdates = ({
  groupNames,
  groups,
  answers,
  visibility,
  serverVisibleByName,
}: DeriveYesGroupUpdatesArgs): {
  answers: Answers;
  visibility: VisibilityMap;
} => {
  let nextAnswers = { ...answers };
  const nextVisibility = { ...visibility };

  for (const child of groupNames) {
    const childGroup = groups[child];
    if (isShadowGroup(childGroup)) {
      nextAnswers[child] = [];
      nextAnswers = deriveShadowChildrenAnswers({
        shadowGroup: childGroup,
        selectedValues: [],
        answers: nextAnswers,
      });
    } else {
      // For non-shadow children, clear any existing answer so it can be re-answered
      delete nextAnswers[child];
    }
    nextVisibility[child] = serverVisibleByName[child] ?? false;
  }

  return { answers: nextAnswers, visibility: nextVisibility };
};
